export default "__VITE_ASSET__i$pra99e__"